import config from '../../config.json';
import apiRequest from '../../utils/api.request';
import { logError } from '../../utils/utils'
import { parseQueryString } from '../../utils/utils'
import getHeaderFromParams from '../index';

export async function srGetUserVaccinationStatus(source) {
  try {
    const url = config.covid_vacc_base_url + "v1/get-user-covid-info/"
    const params = parseQueryString()
    const reqData = getHeaderFromParams(params)
    if (source === 'emp_xp') {
      const data = await apiRequest(
        url,
        reqData,
        true
      )
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'success' })
      })
    }
    else if (source === 'JioHealthHub') {
      const data = await apiRequest(
        url, reqData, true, false, false, false, false, false, false, false, true
      )
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'success' })
      })
    }
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }
}

export async function srGetVaccineOptions() {
  try {
    const url = config.covid_vacc_base_url + "v1/get-covid-vaccine-list/"
    const data = await apiRequest(url)
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }
}

export async function srGetEoiSscParams() {
  try {
    const url = config.covid_vacc_base_url + "v1/get-eoi-ssc-param/"
    const data = await apiRequest(url)
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }
}

export async function srUpdateVaccineInfo(source, requestData) {
  try {
    const url = config.covid_vacc_base_url + "v1/user-reported-vaccine-data/";
    const params = parseQueryString()
    const reqData = {
      ...getHeaderFromParams(params),
      ...requestData
    }
    if (source === 'emp_xp') {
      const data = await apiRequest(
        url,
        reqData,
        true
      )
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'success' })
      })
    }
    else if (source === 'JioHealthHub') {
      const data = await apiRequest(
        url, reqData, true, false, false, false, false, false, false, false, true
      )
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'success' })
      })
    }
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }
}
